import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

import { METRIC_FILTER_OPTIONS } from 'app/hub-components/constants/query-filter.constants';
import { IMetricFilterWrapper } from 'app/hub-components/interfaces/query-filter.interface';
import { Query } from '../../../../models/analytics-api/query.model';
import { Metric, Schema } from '../../../../models/analytics-api/schema.model';
import { QueryFilterOption } from '../../../../models/query-option.model';
import { TrackingService } from '../../../../services/tracking/tracking.service';

@Component({
  selector: 'metric-filters-modal',
  templateUrl: './metric-filters-modal.component.html',
  styleUrls: ['./metric-filters-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class MetricFiltersModalComponent implements OnInit {
  @Input() query: Query;
  @Input() schema: Schema;
  @Input() compatibleMetrics: Metric[];
  @Output() modalMetricFiltersClosed = new EventEmitter<object>();

  public datasetName: string;
  public interval: string;
  public filters: IMetricFilterWrapper[];
  public metricFilterOptions: QueryFilterOption[] = [];
  public emptyFilterExists: boolean = false;
  public infoMessage = [{ severity: 'info', detail: 'Metric filtered rows will show N/A as metric values if you use a Sum By other than Total.' }];

  private updatedMetricFilters: IMetricFilterWrapper[];

  constructor(
    private trackingService: TrackingService,
  ) {}

  public ngOnInit(): void {
    this.datasetName = this.query.dataset;
    this.filters = this.query.metricFilters || [];

    this.interval = this.query.interval;
    this.metricFilterOptions = METRIC_FILTER_OPTIONS;
  }

  public updateFilters(data) {
    this.updatedMetricFilters = data.filters;
    this.emptyFilterExists = data.emptyFilterWarnings.flatten().find(value => value === true);
  }

  public applyFilters(): void {
    this.trackingService.track('Add metric filter and run query');
    const runQuery = this.hasMetrics;
    if (!!this.updatedMetricFilters) {
      this.query.metricFilters = this.updatedMetricFilters;
      this.query.metricFilters.forEach(filter => {
        filter.expressions.forEach(expression => {
          if (expression?.type) {
            const filterType = this.metricFilterOptions.find(mfo => mfo.type === expression.type);
            if (filterType) {
              this.trackingService.track('Apply metric filter', { value: filterType.name });
            }
          }
        });
      });
      this.modalMetricFiltersClosed.emit({ runQuery: runQuery });
    }
  }

  public cancel() {
    this.modalMetricFiltersClosed.emit({ runQuery: false });
  }

  public get hasMetrics(): boolean {
    return !!this.query.metrics.length;
  }
}
